import { render } from "./CookieComplyModal.vue?vue&type=template&id=754d5536"
import script from "./CookieComplyModal.vue?vue&type=script&lang=js"
export * from "./CookieComplyModal.vue?vue&type=script&lang=js"

import "./CookieComplyModal.vue?vue&type=style&index=0&id=754d5536&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__